<div class="hero-section">
  <div class="hero-shell">
    <div class="hero-content">
      <h1 class="hero-title">
        <span class="hero-title-line">Inventory Management</span>
        <span class="hero-title-line hero-title-line--second">made <span class="hero-title-highlight">simple</span>.</span>
      </h1>

      <p class="hero-description">
        Track items, prices, units, and warehouses in real time. Know exactly what you have,
        where it is, and when it's running low — before it becomes a problem.
      </p>

      <div class="hero-buttons">
        <button class="hero-btn hero-btn-primary" type="button" (click)="showRegister = true">Start free trial</button>
        <a class="hero-btn hero-btn-secondary" href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer">Book a meeting</a>
      </div>
    </div>

    <div class="hero-visual" aria-hidden="true">
      <div class="stock-card">
        <div class="stock-card-top">
          <div class="stock-icon">📦</div>
          <div class="stock-info">
            <span class="stock-name">Lifebuoy Soap 100g</span>
            <span class="stock-code">PC-SOAP-LBY100 · Retail Store</span>
          </div>
          <span class="stock-status">Low</span>
        </div>

        <div class="stock-card-row">
          <span>On hand</span>
          <span class="stock-qty">10.00</span>
        </div>
        <div class="stock-card-row">
          <span>Reorder level</span>
          <span class="stock-qty">10.00</span>
        </div>

        <div class="stock-bar"><div class="stock-bar-fill"></div></div>
      </div>

      <div class="floating-chip floating-chip--items">
        <span class="floating-chip-icon">🗂️</span>
        <span>62 items tracked</span>
      </div>

      <div class="floating-chip floating-chip--zero">
        <span class="floating-chip-icon">✅</span>
        <span>0 out of stock</span>
      </div>
    </div>
  </div>
</div>

<app-register
  *ngIf="showRegister"
  [selectedApps]="inventoryApp"
  (goBack)="showRegister = false"
></app-register>
